import { PaymentWindowModeType } from '../../data/_constants';
import { PgType } from '../../context';
import React from 'react';
import cn from 'clsx';
import { toLower } from 'lodash';
import ThemeImg from '@src/view/common/ThemeImg';

const PayMethodItem = (children: React.ReactNode) => {
  return <span>{children}</span>;
};

interface PgMethodPropTypes {
  pgItem: PgType.MethodItemType;
  windowMode: PaymentWindowModeType;
  selectPgItem?: PgType.MethodItemType | null;
  title?: string;
  onClick: (e: any) => void;
}

/**
 * 결제 수단 dom, eximbay, payletter, unionpay, paymentwall, gpay, applepay
 * @returns
 */

const Eximbay = (props: PgMethodPropTypes) => {
  const { pgItem, windowMode, onClick } = props;
  const { pg, display } = pgItem;

  return (
    <>
      {/* 상단 라벨 */}
      <div
        className={cn(
          'absolute text-[#1e1f21] bg-[#528dff] text-[10px] rounded-[12px] -translate-x-[50%] leading-[1.05rem] -top-[10px] left-[50%] min-w-[75px] px-[6px] text-center',
          'dark:text-[#1e1f21] dark:bg-[#528dff]',
        )}
      >
        Fast & Easy
      </div>
      {/* 상단 라벨 */}

      <button
        type="button"
        className={cn(
          'relative h-full w-full flex flex-col justify-end items-center',
          {
            'min-h-[100px] mo:min-h-[74px]':
              windowMode === PaymentWindowModeType.LARGE,
            'min-h-[74px] my-0 mx-auto':
              windowMode === PaymentWindowModeType.MINI,
          },
        )}
        onClick={onClick}
      >
        <span
          className={cn('text-[#ccc]', 'mo:text-[#222]', 'tablet:text-[#bbb]', {
            'min-h-[34px]': windowMode === PaymentWindowModeType.LARGE,
          })}
        >
          <img
            className={cn('w-full mx-auto', {
              'max-w-[170px] mo:max-w-[130px]':
                windowMode === PaymentWindowModeType.LARGE,
              'max-w-[130px]': windowMode === PaymentWindowModeType.MINI,
            })}
            src={`/images/payment/pgIcons/icon_${pg}_dk.png`}
            alt={`icon-${pg}`}
          />
        </span>

        <div
          className={cn(
            'w-full bg-[#1A1B1C] flex items-center justify-center',
            {
              'min-h-[44px] mo:min-h-[30px]':
                windowMode === PaymentWindowModeType.LARGE,
              'min-h-[26px] max-h-[26px]':
                windowMode === PaymentWindowModeType.MINI,
            },
          )}
        >
          {['visa', 'mastercard', 'amex', 'jcb'].map(item => {
            return (
              <span key={`pg-item-${item}`} className="inline-block">
                <img
                  className={cn({
                    'max-w-[45px] mo:max-h-[20px]':
                      windowMode === PaymentWindowModeType.LARGE,
                    'max-h-[20px]': windowMode === PaymentWindowModeType.MINI,
                  })}
                  src={`/images/payment/${item}.png`}
                  alt="visa"
                />
              </span>
            );
          })}
        </div>

        {/* 개발자 모드 뱃지 */}
        {display === 2 && <DevBadge />}
      </button>
    </>
  );
};

const Payletter = (props: PgMethodPropTypes) => {
  const { pgItem, windowMode, onClick } = props;
  const { pg, display } = pgItem;

  return (
    <>
      {/* 상단 라벨 */}
      <div className="absolute leading-[1.05rem] -top-[10px] left-[50%] min-w-[75px] px-[6px] text-center text-[#1e1f21] text-[10px] rounded-[12px] bg-[#ff4f4f] -translate-x-[50%]">
        3D Secure
      </div>
      {/* 상단 라벨 */}

      <button
        type="button"
        className={cn(
          'relative h-full w-full flex flex-col justify-end items-center',
          {
            'min-h-[100px] mo:min-h-[74px]':
              windowMode === PaymentWindowModeType.LARGE,
            'min-h-[74px] my-0 mx-auto':
              windowMode === PaymentWindowModeType.MINI,
          },
        )}
        onClick={onClick}
      >
        <span
          className={cn('text-[#ccc]', 'mo:text-[#222]', 'tablet:text-[#bbb]', {
            'min-h-[34px]': windowMode === PaymentWindowModeType.LARGE,
          })}
        >
          <img
            className={cn('w-full mx-auto', {
              'max-w-[170px] mo:max-w-[130px]':
                windowMode === PaymentWindowModeType.LARGE,
              'max-w-[130px]': windowMode === PaymentWindowModeType.MINI,
            })}
            src={`/images/payment/pgIcons/icon_${pg}_dk.png`}
            alt={`icon-${pg}`}
          />
        </span>

        <div
          className={cn(
            'w-full bg-[#1A1B1C] flex items-center justify-center',
            {
              'min-h-[44px] mo:min-h-[30px]':
                windowMode === PaymentWindowModeType.LARGE,
              'min-h-[26px] max-h-[26px]':
                windowMode === PaymentWindowModeType.MINI,
            },
          )}
        >
          {['visa', 'mastercard', 'jcb'].map(item => {
            return (
              <span key={`pg-item-${item}`} className="inline-block">
                <img
                  className={cn({
                    'max-w-[45px] mo:max-h-[20px]':
                      windowMode === PaymentWindowModeType.LARGE,
                    'max-h-[20px]': windowMode === PaymentWindowModeType.MINI,
                  })}
                  src={`/images/payment/${item}.png`}
                  alt="visa"
                />
              </span>
            );
          })}
        </div>

        {/* 개발자 모드 뱃지 */}
        {display === 2 && <DevBadge />}
      </button>
    </>
  );
};

const UnionPay = (props: PgMethodPropTypes) => {
  const { pgItem, windowMode, onClick } = props;
  const { display, method } = pgItem;

  return (
    <button
      type="button"
      className={cn('relative block h-full w-full', {
        'min-h-[100px] mo:min-h-[74px] px-[30px] mo:px-[5px]':
          windowMode === PaymentWindowModeType.LARGE,
        'min-h-[74px] my-0 mx-auto': windowMode === PaymentWindowModeType.MINI,
      })}
      onClick={onClick}
    >
      <span
        className={cn('text-[#ccc]', 'mo:text-[#222]', 'tablet:text-[#bbb]', {
          'min-h-[34px]': windowMode === PaymentWindowModeType.LARGE,
        })}
      >
        <img
          className={cn('w-full mx-auto', {
            'max-w-[170px] mo:max-w-[130px]':
              windowMode === PaymentWindowModeType.LARGE,
            'max-w-[130px]': windowMode === PaymentWindowModeType.MINI,
          })}
          src={`/images/payment/pgIcons/icon_${method}_dk.png`}
          alt={`icon-${method}`}
        />
      </span>
      {/* 개발자 모드 뱃지 */}
      {display === 2 && <DevBadge />}
    </button>
  );
};

const PaymentWall = (props: PgMethodPropTypes) => {
  const { pgItem, windowMode, onClick } = props;
  const { pg, display, method } = pgItem;

  return (
    <>
      {/* 상단라벨 */}
      <div className="absolute leading-[1.05rem] -top-[10px] left-[50%] min-w-[96px] px-[6px] text-center text-[#1e1f21] text-[10px] rounded-[12px] bg-[#FFC452] -translate-x-[50%]">
        Local Payments
      </div>
      {/* 상단라벨 */}

      <button
        type="button"
        className={cn(
          'relative h-full w-full flex flex-col justify-end items-center',
          {
            'min-h-[100px] mo:min-h-[74px]':
              windowMode === PaymentWindowModeType.LARGE,
            'min-h-[74px] my-0 mx-auto':
              windowMode === PaymentWindowModeType.MINI,
          },
        )}
        onClick={onClick}
      >
        <span
          className={cn('text-[#ccc]', 'mo:text-[#222]', 'tablet:text-[#bbb]', {
            'min-h-[34px]': windowMode === PaymentWindowModeType.LARGE,
          })}
        >
          <img
            className={cn('w-full mx-auto', {
              'max-w-[170px] mo:max-w-[130px]':
                windowMode === PaymentWindowModeType.LARGE,
              'max-w-[130px]': windowMode === PaymentWindowModeType.MINI,
            })}
            src={`/images/payment/pgIcons/icon_${pg}_dk.png`}
            alt={`icon-${pg}`}
          />
        </span>

        <div
          className={cn(
            'w-full bg-[#1A1B1C] flex items-center justify-center',
            {
              'min-h-[44px] mo:min-h-[30px]':
                windowMode === PaymentWindowModeType.LARGE,
              'min-h-[26px] max-h-[26px]':
                windowMode === PaymentWindowModeType.MINI,
            },
          )}
        >
          {['visa', 'mastercard', 'jcb'].map(item => {
            return (
              <span key={`pg-item-${item}`} className="inline-block">
                <img
                  className={cn({
                    'max-w-[45px] mo:max-h-[20px]':
                      windowMode === PaymentWindowModeType.LARGE,
                    'max-h-[20px]': windowMode === PaymentWindowModeType.MINI,
                  })}
                  src={`/images/payment/${item}.png`}
                  alt="visa"
                />
              </span>
            );
          })}
        </div>

        {/* 개발자 모드 뱃지 */}
        {display === 2 && <DevBadge />}
      </button>
    </>
  );
};

const NormalPay = (props: PgMethodPropTypes) => {
  const { pgItem, windowMode, onClick } = props;
  const { pg, display, method } = pgItem;
  const methodLowerCase = toLower(method);

  return (
    <button
      type="button"
      className={cn(
        'w-full border-[#DDDDDD] dark:border-[#3F3F3F] dark:bg-[#252525] bg-[#FFFFFF] relative block border border-solid',
        {
          'h-[150px] mo:h-[65px] min-h-[44px] mo:min-h-[30px]':
            windowMode === PaymentWindowModeType.LARGE,
          'h-[65px] min-h-[26px]': windowMode === PaymentWindowModeType.MINI,
        },
      )}
      onClick={onClick}
    >
      <span
        className={cn('text-[#ccc]', 'mo:text-[#222]', 'tablet:text-[#bbb]')}
      >
        <ThemeImg
          className={cn('w-full mx-auto', {
            'max-w-[170px] mo:max-w-[130px]':
              windowMode === PaymentWindowModeType.LARGE,
            'max-w-[130px]': windowMode === PaymentWindowModeType.MINI,
          })}
          lightImg={`/images/payment/light/pgIcons/pay_${pg}${method ? `_${method}` : ''
            }.png`}
          darkImg={`/images/payment/dark/pgIcons/pay_${pg}${method ? `_${method}` : ''
            }.png`}
          alt={`icon-${method ? methodLowerCase : pg}`}
        />
      </span>
      {/* 개발자 모드 뱃지 */}
      {display === 2 && <DevBadge />}
    </button>
  );
};

const CreditCardsV2 = () => {
  return (
    <div className='flex flex-row items-center gap-2 w-full justify-center'>
      <ThemeImg
        className={cn('w-[24px] h-[24px]', {
          'mo:w-[18px] mo:h-[18px]':
            'PAYMENT_PAGE' === PaymentWindowModeType.LARGE,
          'w-[18px] h-[18px]': 'PAYMENT_MODAL' === PaymentWindowModeType.MINI,
        })}
        lightImg={`/images/payment/dark/pg_card.png`}
        darkImg={`/images/payment/dark/pg_card.png`}
        alt={`icon-${1 ? 'cc' : 'paymentwall'}`}
      />
      <span
        className={cn('text-[16px] text-white ', {
          'mo:text-[13px] mo:font-medium':
            'PAYMENT_PAGE' === PaymentWindowModeType.LARGE,
          'text-[13px] font-medium':
            'PAYMENT_MODAL' === PaymentWindowModeType.MINI,
        })}
      >
        {"Credit & Debit Cards"}
      </span>
    </div>
  )
}


const Paypal = () => {
  return (
    <div className='flex flex-row items-center gap-2 w-full justify-center'>
      <span
        className={cn('text-[16px] text-black ', {
          'mo:text-[13px] mo:font-medium':
            'PAYMENT_PAGE' === PaymentWindowModeType.LARGE,
          'text-[13px] font-medium':
            'PAYMENT_MODAL' === PaymentWindowModeType.MINI,
        })}
      >
        {"Pay with"}
      </span>
      <ThemeImg
        className='h-6'
        lightImg={`/images/payment/light/pgIcons/img_payment_paypal.png`}
        darkImg={`/images/payment/dark/pgIcons/img_payment_paypal.png`}
        alt={`icon-paypal`}
      />
    </div>
  )
}

const Google = () => {
  return (
    <div className='flex flex-row items-center gap-2 w-full justify-center'>
      <span
        className={cn('text-[16px] text-black', {
          'mo:text-[13px] mo:font-medium':
            'PAYMENT_PAGE' === PaymentWindowModeType.LARGE,
          'text-[13px] font-medium':
            'PAYMENT_MODAL' === PaymentWindowModeType.MINI,
        })}
      >
        {"Pay with"}
      </span>
      <ThemeImg
        className='w-12'
        lightImg={`/images/payment/light/pgIcons/img_payment_google.svg`}
        darkImg={`/images/payment/dark/pgIcons/img_payment_google.svg`}
        alt={`icon-goggle`}
      />
    </div>
  )
}

const Apple = () => {
  return (
    <div className='flex flex-row items-center gap-2 w-full justify-center'>
      <span
        className={cn('text-[16px] text-black', {
          'mo:text-[13px] mo:font-medium':
            'PAYMENT_PAGE' === PaymentWindowModeType.LARGE,
          'text-[13px] font-medium':
            'PAYMENT_MODAL' === PaymentWindowModeType.MINI,
        })}
      >
        {"Pay with"}
      </span>
      <ThemeImg
        className='w-12'
        lightImg={`/images/payment/light/pgIcons/img_payment_apple.svg`}
        darkImg={`/images/payment/dark/pgIcons/img_payment_apple.svg`}
        alt={`icon-goggle`}
      />
    </div>
  )
}


const CreditCards = (props: PgMethodPropTypes) => {
  const { pgItem, windowMode, onClick, title } = props;
  const { pg, display, method } = pgItem;
  const methodLowerCase = toLower(method);
  return (
    <button
      key={`pg-item-${title}}`}
      className={cn(
        'relative w-full dark:bg-[#252525] bg-[#FFFFFF] border border-solid border-[#DDDDDD] dark:border-[#3F3F3F] flex flex-col justify-between',
        {
          'h-[150px] mo:h-[110px] p-[25px_20px] mo:p-[15px_20px]':
            windowMode === PaymentWindowModeType.LARGE,
          'p-[15px_20px] h-[110px]': windowMode === PaymentWindowModeType.MINI,
        },
      )}
      onClick={onClick}
    >
      <div className="flex flex-row items-center justify-start gap-[5px]">
        <ThemeImg
          className={cn('w-[24px] h-[24px]', {
            'mo:w-[18px] mo:h-[18px]':
              windowMode === PaymentWindowModeType.LARGE,
            'w-[18px] h-[18px]': windowMode === PaymentWindowModeType.MINI,
          })}
          lightImg={`/images/payment/light/pg_card.png`}
          darkImg={`/images/payment/dark/pg_card.png`}
          alt={`icon-${method ? methodLowerCase : pg}`}
        />
        <span
          className={cn('text-[16px] text-blackWhite ', {
            'mo:text-[13px] mo:font-medium':
              windowMode === PaymentWindowModeType.LARGE,
            'text-[13px] font-medium':
              windowMode === PaymentWindowModeType.MINI,
          })}
        >
          {title}
        </span>
      </div>
      <span className={cn('')}>
        <ThemeImg
          className={cn('mx-auto h-[30x]', {})}
          lightImg={`/images/payment/light/pgIcons/pay_${pg}${method ? `_${method}` : ''
            }.png`}
          darkImg={`/images/payment/dark/pgIcons/pay_${pg}${method ? `_${method}` : ''
            }.png`}
          alt={`icon-${method ? methodLowerCase : pg}`}
        />
      </span>
      {/* 개발자 모드 뱃지 */}
      {display === 2 && <DevBadge />}
    </button>
  );
};

const MiniRefillPay = (props: PgMethodPropTypes) => {
  const { pgItem, windowMode, onClick } = props;
  const { pg, display, method } = pgItem;
  const methodLowerCase = toLower(method);

  return (
    <button
      type="button"
      className={cn(
        'block w-full h-full px-[30px] mo:px-[5px]  min-h-[75px]  border border-solid border-primary-border relative',
      )}
      onClick={onClick}
    >
      <span className={cn('text-[#222]')}>
        <img
          className={cn('w-full mx-auto max-w-[170px] mo:max-w-[130px]')}
          src={`/images/payment/light/pgIcons/pay_${pg}${method ? `_${method}` : ''
            }.png`}
          alt={`icon-${method ? methodLowerCase : pg}`}
        />
      </span>
      {/* 개발자 모드 뱃지 */}
      {display === 2 && <DevBadge />}
    </button>
  );
};

/**
 * 개발모드 뱃지 중복 하나로 통합
 * @returns
 */
const DevBadge = () => {
  return (
    <div className="absolute leading-[1.05rem] mo:leading-[0.95rem] bottom-[0] right-[0] min-w-[60px] mo:min-w-[30px] px-[6px] text-center text-[#1e1f21] text-[14px] mo:text-[10px] bg-[#fdff89]">
      dev
    </div>
  );
};

const MiniPaymentMethod = (props: PgMethodPropTypes) => {
  const { pgItem, windowMode, onClick, selectPgItem } = props;
  const { pg, display, method } = pgItem;
  const methodLowerCase = toLower(method);

  return (
    <button
      type="button"
      className={cn(
        'flex-1 h-[62px] rounded-[10px] relative block shadow-miniPaymentMethod cursor-pointer',
        {
          ['bg-miniPaymentMethodActive p-[2px]']:
            selectPgItem?.method === pgItem.method,
          ['border border-solid border-[#DDDDDD] dark:border-[#404040]']:
            !selectPgItem || selectPgItem?.method !== pgItem.method,
        },
      )}
      onClick={onClick}
    >
      <div
        className={cn(
          'w-full h-full flex justify-center items-center dark:bg-[#252525] bg-white',
          {
            ['rounded-[7px] bg-[#fffcf5] dark:bg-[#2B0D0D]']:
              selectPgItem?.method === pgItem.method,
            ['rounded-[10px]']:
              !selectPgItem || selectPgItem?.method !== pgItem.method,
          },
        )}
      >
        {method !== 'cc' ? (
          <span className={cn('')}>
            <ThemeImg
              className={cn('mx-auto h-[25px]', {})}
              lightImg={`/images/payment/light/pgIcons/pay_${pg}${method ? `_${method}` : ''
                }.png`}
              darkImg={`/images/payment/dark/pgIcons/pay_${pg}${method ? `_${method}` : ''
                }.png`}
              alt={`icon-${method ? methodLowerCase : pg}`}
            />
          </span>
        ) : (
          <div className="flex flex-col items-center justify-center gap-[8px]">
            <img
              className="w-[25px]"
              src={'/images/payment/mini_pg_card.png'}
              alt="cc_card_image"
            />
            <span
              className={cn(
                'text-[#999] text-[11px] font-medium leading-none',
                {
                  ['text-[#2355F6]']: selectPgItem?.method === pgItem.method,
                  ['text-[#999]']:
                    !selectPgItem || selectPgItem?.method !== pgItem.method,
                },
              )}
            >
              Credit Card
            </span>
          </div>
        )}

        {/* 개발자 모드 뱃지 */}
        {display === 2 && <DevBadge />}
      </div>
    </button>
  );
};

PayMethodItem.Apple = Apple;
PayMethodItem.Goggle = Google;
PayMethodItem.Paypal = Paypal;
PayMethodItem.Eximbay = Eximbay;
PayMethodItem.Payletter = Payletter;
PayMethodItem.UnionPay = UnionPay;
PayMethodItem.PaymentWall = PaymentWall;
PayMethodItem.NormalPay = NormalPay;
PayMethodItem.CreditCards = CreditCards;
PayMethodItem.CreditCardsV2 = CreditCardsV2;
PayMethodItem.MiniRefillPay = MiniRefillPay;
PayMethodItem.MiniPaymentMethod = MiniPaymentMethod;
PayMethodItem.DevBadge = DevBadge;
export default PayMethodItem;
